import { render, staticRenderFns } from "./CardChannelPlanSummary.vue?vue&type=template&id=6a771c68&scoped=true"
import script from "./CardChannelPlanSummary.vue?vue&type=script&lang=ts"
export * from "./CardChannelPlanSummary.vue?vue&type=script&lang=ts"
import style0 from "./CardChannelPlanSummary.vue?vue&type=style&index=0&id=6a771c68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a771c68",
  null
  
)

export default component.exports